import React from 'react';

export default class Page1 extends React.Component {

    render() {

        return <div id="region-main-pad">
            <div id="region-main"><span id="user-notifications"/>
                <div className="region-content">
                    <div role="main"><span id="maincontent"/>
                        <section>
                            <div className="">
                                <div className="ilead-rgt">
                                    <div className="innerpadding">
                                        <div className="innovativeimg">
                                            <img alt="" style={{maxWidth: '100%'}}
                                                 src={require('@images/How to focus on the bigger picture.png')}/>
                                        </div>

                                        <div className="ilead-contentarea">

                                            <div className="circle_title"><span className="heading"><img
                                                src={require('@images/greendot.jpg')}
                                                className="heading_imag"/></span><span className="heading">
isn't it interesting?
</span></div>
                                            <img className="thought-imgpadbtm" alt=""
                                                 src={require('@images/twins.png')}
                                                 style={{float: 'left'}}/>
                                            <p style={{float: 'left', clear: 'right', paddingTop: '2%'}}>Take a
                                                look at the faces in the picture.
                                                Are they angry or calm?</p>
                                            <div className="border_subtitle" style={{clear: 'both'}}>Dr
                                                Angry and Mr Smile
                                            </div>
                                            <div className="uiheading"><p
                                                className="homepage-marginpad">The person on the left
                                                appears to have a frown and snarl, giving an impression
                                                that they are angry.
                                                In contrast, the wide eyed person on the right with a
                                                hazy focus appears calm and relaxed. Now step
                                                back and look at the picture from about 12 feet away.
                                                Now, which face is calm and which face is
                                                angry? You will notice that they appear to have swapped;
                                                the person to the left now looks wide eyed
                                                and calm and the one on the right looks like they are
                                                frowning and angry! But why is this?</p></div>

                                            <div className="lightgreencontentbg">
                                                <div className="border_subtitle">Just a matter of
                                                    perspective?
                                                </div>
                                                <p>Depending on the distance you look at this picture
                                                    from you see something totally different.
                                                    This diagram, called a hybrid image,<a
                                                        className="superscripttext"
                                                        href="further_info.php?page=1&amp;course=300"><sup>1</sup></a> was
                                                    designed to illustrate the ability of the visual
                                                    system
                                                    to separate information coming from different
                                                    spatial frequency channels, i.e. how you perceive
                                                    the same information at different depths using
                                                    various parts of the eye and brain.</p>
                                                <div className="uiheading"><p>This change in
                                                    perspectives often applies to work situations. The
                                                    decisions, opinions and
                                                    solutions you choose are likely to differ depending
                                                    on the perspective from which you view a
                                                    task or problem. Often, if you take a step back and
                                                    look at the bigger picture you could come
                                                    up with a completely different solution than by
                                                    considering every point in detail.</p></div>
                                            </div>


                                            <div className="right-btn">
                                                <div
                                                    onClick={this.props.handleChangePage('Page2')}
                                                    className="button-next-previous-done thought">Next &gt;&gt;</div>
                                            </div>


                                        </div>

                                    </div>


                                </div>


                            </div>
                        </section>
                    </div>
                </div>
            </div>
        </div>;
    }
}